<div
  class="ui-nav-select"
  [class.ui-nav-select--open]="isOpen()"
  [class.ui-nav-select--disabled]="disabled()"
>
  <button
    type="button"
    class="ui-nav-select__trigger"
    [class.ui-nav-select__trigger--open]="isOpen()"
    [class.ui-nav-select__trigger--has-value]="selectedLabel() !== null"
    [disabled]="disabled()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="listbox"
    [attr.aria-controls]="panelId"
    [attr.aria-label]="ariaLabel()"
    (click)="toggle($event)"
  >
    @if (iconSrc()) {
      <img
        class="ui-nav-select__icon"
        [src]="iconSrc()!"
        alt=""
        aria-hidden="true"
        width="18"
        height="18"
      />
    }
    <span class="ui-nav-select__label">{{ selectedLabel() ?? placeholder() }}</span>
    <span class="ui-nav-select__chevron" aria-hidden="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </span>
  </button>

  @if (isOpen()) {
    <ul
      class="ui-nav-select__panel"
      [id]="panelId"
      role="listbox"
      [attr.aria-label]="ariaLabel()"
      (click)="$event.stopPropagation()"
    >
      @for (option of options(); track option.value) {
        <li
          class="ui-nav-select__option"
          [class.ui-nav-select__option--selected]="option.value === value()"
          role="option"
          [attr.aria-selected]="option.value === value()"
          (click)="select(option, $event)"
        >
          <span class="ui-nav-select__option-label">{{ option.label }}</span>
          @if (option.value === value()) {
            <span class="ui-nav-select__option-check" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </span>
          }
        </li>
      }
    </ul>
  }
</div>
